import { PromotionLayout } from '../PromotionLayout';
import { PromotionLabelContainer } from '../PromotionLabel';
import * as React from 'react';
import { EServiceId, EUnavailableReason } from '../../../../../../types/reducers/publishTerms';
import { useSelector } from 'react-redux';
import {
  selectActiveOrPromotionServiceId,
  selectIsPromotionPackageSelected,
  selectServiceUnavailableReason,
} from '../../../../../../selectors/publishTerms';
import { ECheckServiceStatus } from '../../../../../../types/reducers/checkoutInfo';
import { EBetPositionStatus } from '../../../../../../types/reducers/betPosition';
import { selectCheckServiceStatus } from '../../../../../../selectors/checkoutInfo';
import {
  selectBetPosition,
  selectBetPositionStatus,
  selectTopAuctionBetPosition,
} from '../../../../../../selectors/betPosition';
import { BetPositionMobileTooltip } from '../BetPositionMobileTooltip';
import { getLeadBetPositionText } from '../../utils';

export const PromotionContainer = () => {
  const unavailableReason = useSelector(selectServiceUnavailableReason);
  const checkServiceStatus = useSelector(selectCheckServiceStatus);
  const betPositionStatus = useSelector(selectBetPositionStatus);
  const selectedTopAuctionServiceId = useSelector(selectActiveOrPromotionServiceId);
  const topAuctionBetPosition = useSelector(selectTopAuctionBetPosition);
  const isPromotionPackageSelected = useSelector(selectIsPromotionPackageSelected);
  const promotionPackageBetPosition = useSelector(selectBetPosition);

  const promotionPackageBetPositionTooltip = isPromotionPackageSelected && promotionPackageBetPosition && (
    <BetPositionMobileTooltip>{getLeadBetPositionText(promotionPackageBetPosition)}</BetPositionMobileTooltip>
  );

  const isLoading =
    checkServiceStatus === ECheckServiceStatus.pending || betPositionStatus === EBetPositionStatus.pending;

  const isValidUnavailableReason = unavailableReason && unavailableReason !== EUnavailableReason.noPhotos;
  const topAuctionBetPositionTooltip = selectedTopAuctionServiceId === EServiceId.top && topAuctionBetPosition && (
    <BetPositionMobileTooltip>{getLeadBetPositionText(topAuctionBetPosition)}</BetPositionMobileTooltip>
  );

  if (isValidUnavailableReason) {
    return null;
  }

  return (
    <PromotionLayout
      loading={isLoading}
      promotionLabel={<PromotionLabelContainer />}
      betPosition={topAuctionBetPositionTooltip || promotionPackageBetPositionTooltip}
    />
  );
};
